export default __webpack_public_path__ + "static/media/fishdom@2x.e0eea734.webp";